import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { scrollToSection } from "../../hooks/useLenis";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => scrollToSection("top");

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          key="scroll-top"
          initial={{ opacity: 0, y: 14, scale: 0.9 }}
          animate={{ opacity: 1, y: 0,  scale: 1   }}
          exit={{    opacity: 0, y: 14, scale: 0.9 }}
          transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
          onClick={handleClick}
          aria-label="Wróć na górę"
          style={{
            position: "fixed",
            bottom: "5.5rem",
            right: "1.5rem",
            zIndex: 200,
            width: 44,
            height: 44,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(16,15,12,0.88)",
            border: "1px solid rgba(200,121,65,0.35)",
            color: "#C87941",
            backdropFilter: "blur(14px)",
            WebkitBackdropFilter: "blur(14px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.45)",
            cursor: "pointer",
            transition:
              "border-color 250ms ease, background 250ms ease, box-shadow 250ms ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor  = "rgba(200,121,65,0.65)";
            e.currentTarget.style.background   = "rgba(200,121,65,0.10)";
            e.currentTarget.style.boxShadow    = "0 4px 24px rgba(200,121,65,0.22)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor  = "rgba(200,121,65,0.35)";
            e.currentTarget.style.background   = "rgba(16,15,12,0.88)";
            e.currentTarget.style.boxShadow    = "0 4px 20px rgba(0,0,0,0.45)";
          }}
        >
          <ArrowUp size={16} strokeWidth={1.8} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
